/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import 'moment/min/locales';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import BadgeStatus from './BadgeStatus';
import styles from './badginglist.module.scss';
import { initiateBadgeDelete } from '../redux/actions';
import DeleteConfirmation from '../../../components/deleteConfirmation/deleteConfirmation';
import { renderInfoForType } from '../../../utils/helpers';
import Collapsible from '../../../components/collapsible/Collapsible';
import Clickable from '../../../components/clickable/Clickable';


const Table = ({ info, permissions }) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [id, setid] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [applicationFilled, setApplicationFilled] = useState('');
  const [openRow, setOpenRow] = useState(null);
  const history = useHistory();
  const handleClick = (event, clickId, status, application_filled_by) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setid(clickId);
    setApplicationFilled(application_filled_by);
  };
  const toggleConfirmDelete = () => {
    setConfirmDelete(!confirmDelete);
  };
  const handleConfirmDelete = () => {
    setConfirmDelete(true);
  };
  const remove = () => {
    dispatch(initiateBadgeDelete(id));
    setConfirmDelete(false);
  };
  return (
    <>
    <table className={`${styles.table}`}>
      <thead>
        <tr className={styles.tHeadRow}>
          <th style={{ padding: '0 18px', width: '178px' }}>
            <FormattedMessage id="fod_log_list.date" defaultMessage="Date Submitted" />
          </th>
          <th width="193">
            <FormattedMessage id="wildlife.form.name" defaultMessage="Applicant Name" />
          </th>
          <th width="265">
            <FormattedMessage id="badge.info.date_of_birth" defaultMessage="Applicant Date of Birth" />
          </th>
          <th>
            <FormattedMessage id="lease.tenants.list.company" defaultMessage="company" />
          </th>
          <th>
            <FormattedMessage id="inspections.answer_details.status" defaultMessage="Status" />
          </th>
          <th width="100" />
        </tr>
      </thead>
      <tbody>
        {
        Object.keys(info)?.map((e) => {
          const row = info[e];
          return (
          <>
            <tr>
              <td className={styles.date}>{(renderInfoForType({ type: 'date' }, info[e].created_at))}</td>
              <td>
                {info[e].first_name}
                {' '}
                {info[e].last_name}
              </td>
              <td>
                {info[e]?.response?.date_of_birth && (renderInfoForType({ type: 'date' }, info[e]?.response.date_of_birth))}
              </td>
              <td>{info[e].company_name && info[e].company_name.name}</td>
              <td><BadgeStatus item={info[e].status} /></td>
              <td>
                  <div className={styles.documentColumn}>
                  <Collapsible
                    title="workorders.detail.actionBtn"
                    styleClasses={styles.actionsBtn} dateFilter
                    openOnMount={openRow === row.id}
                    badgingOnClick={(event) => {
                        handleClick(
                          event,
                          row.id,
                          row.status,
                          row.application_filled_by
                        );
                        setOpenRow(prev => (prev === row.id ? null : row.id));
                      }}
                    >
                    <ul className={`${styles.dropdown} ${styles.open}`}>
                      {(row?.status === 6) && (
                        <li className={styles.item}>
                            <Clickable className={styles.action} onClick={() => history.push(`/badging/${row.id}/edit_initiate`)}>
                             <FormattedMessage id="shifts.timepicker.edit" defaultMessage="Edit" />
                            </Clickable>
                        </li>
                      )}
                        <li className={styles.item}>
                            <Clickable className={styles.action} onClick={() => history.push(`/badging/${row.id}/detail`)}>
                             <FormattedMessage id="workorders.list.table.action" defaultMessage="View" />
                            </Clickable>
                        </li>
                        {(row.status === 7 && applicationFilled === 'Signatory') && (
                          <li className={styles.item}>
                            <Clickable className={styles.action} onClick={() => history.push(`/badging/${row.id}/renew`)}>
                             <FormattedMessage id="workorders.list.table.renew" defaultMessage="Renew" />
                            </Clickable>
                          </li>
                        )}
                        {permissions && permissions?.signitory_review?.Delete && (
                          <li className={styles.item}>
                            <Clickable className={styles.action} onClick={() => handleConfirmDelete()}>
                              <FormattedMessage id="assets.delete" defaultMessage="Delete" />
                            </Clickable>
                          </li>
                        )}
                    </ul>
                  </Collapsible>
                  </div>
              </td>
            </tr>
          </>
        );
        })}
      </tbody>
    </table>
      <DeleteConfirmation
        isActive={confirmDelete}
        onClose={() => toggleConfirmDelete()}
        confirmDelete={() => remove()}
      />
    </>
  );
};

Table.propTypes = {
  info: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default Table;
